import actions from '@/core/store/penalidades/notificacoes/actions'

export default {
	actions,
}
